import React, { useState, useCallback } from 'react';

import BooksOptionsList from './components/BooksOptionsList';
import { Option } from '../../../../../interfaces/merchants/resources/books';

interface Props {
  options: Option[];
  checkedOptions: Option[];
  onClick: (options: Option[]) => void;
}

interface OptionStatus {
  [id: number]: Option;
}

const applyChange = (
  options: OptionStatus,
  option: Option,
  checked: boolean,
): { [id: number]: Option } => {
  if (checked) {
    return { ...options, [option.id]: option };
  }
  const _options = { ...options };
  delete _options[option.id];
  return _options;
};

const InputBookingTargetOptionSelector: React.FC<Props> = ({
  options,
  checkedOptions,
  onClick,
}) => {
  const [optionStatus, setOptionStatus] = useState<OptionStatus>({});

  const handleClickOption = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const option = options.find(
        (o) => String(o.id) === e.currentTarget.value,
      )!;
      const checked = e.currentTarget.checked;

      const newOptions = applyChange(optionStatus, option, checked);
      setOptionStatus(newOptions);
      onClick(Object.values(newOptions));
    },
    [optionStatus, onClick, options],
  );

  return (
    <BooksOptionsList
      options={options}
      checkedOptions={checkedOptions}
      onChange={handleClickOption}
    />
  );
};

export default InputBookingTargetOptionSelector;
